import React from "react";
import { Container, Paper, 
    AppBar, Grid } from "@mui/material";
import customerService from "../../service/serviceCustomer";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AddIcon from '@mui/icons-material/Add';
import Toolbar from '@mui/material/Toolbar';
import CustomizedBreadcrumbs from "../../component/breadcrumbs/breadcrumbs";
import { Button } from "antd";
import TableCustomer from "../../component/table-customer/table-customer";
import DrawerPrincipal from "../../component/drawer/drawer-principal";
import SimpleBackdrop from "../../component/loading/loading";

function ListCustomer(){

    const usuario = JSON.parse(localStorage.getItem('user_token')) || {};
    const permission = usuario.roles?.filter(item=>item.name == "Cliente")[0];

    const [listCustomer, setListCustomer] = useState({
        data: [],
        pagination: {
            currentPage: 1,
            totalPages: 0,
            totalItems: 0,
            itemsPerPage: 10,
            hasNext: false,
            hasPrev: false,
        }
    });
    const [loading, setLoading] = useState(1);
    const [open, setOpen] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [filters, setFilters] = useState({});
    const [sortBy, setSortBy] = useState(null);
    const [sortOrder, setSortOrder] = useState(null);

    useEffect(() => {
        (async () => {
            setOpen(true);
            
            try {
                const item = await customerService.listCustomerActive(1, 10000);
                
                if (item && item.success !== false) {
                    // Se a API retorna dados paginados
                    if (item.data && Array.isArray(item.data) && item.pagination) {
                        setListCustomer({
                            data: item.data,
                            pagination: item.pagination,
                        });
                    }
                    // Se a API retorna apenas um array (compatibilidade)
                    else if (Array.isArray(item)) {
                        setListCustomer({
                            data: item,
                            pagination: {
                                currentPage: 1,
                                totalPages: 0,
                                totalItems: item.length,
                                itemsPerPage: 10,
                                hasNext: false,
                                hasPrev: false,
                            }
                        });
                    }
                    else {
                        console.error("Resposta inválida da API:", item);
                        setListCustomer({
                            data: [],
                            pagination: {
                                currentPage: 1,
                                totalPages: 0,
                                totalItems: 0,
                                itemsPerPage: 10,
                                hasNext: false,
                                hasPrev: false,
                            }
                        });
                    }
                }
                else if (item && item.success === false) {
                    console.error("Erro na API:", item.message);
                    setErrorMessage(item.message);
                    setListCustomer({
                        data: [],
                        pagination: {
                            currentPage: 1,
                            totalPages: 0,
                            totalItems: 0,
                            itemsPerPage: 10,
                            hasNext: false,
                            hasPrev: false,
                        }
                    });
                }
            } catch (error) {
                console.error("Erro na requisição:", error);
                setListCustomer({
                    data: [],
                    pagination: {
                        currentPage: 1,
                        totalPages: 0,
                        totalItems: 0,
                        itemsPerPage: 10,
                        hasNext: false,
                        hasPrev: false,
                    }
                });
                setErrorMessage(error.message || "Erro ao carregar clientes");
            } finally {
                setOpen(false);
                setLoading(0);
            }
        })();
    }, []);

    const loadPage = async (page, pageSize, customFilters, customSortBy, customSortOrder) => {
        // Se customFilters foi passado explicitamente, usa ele; senão usa o estado
        const filtersToUse = customFilters !== undefined ? customFilters : filters;
        const sortByToUse = customSortBy !== undefined ? customSortBy : sortBy;
        const sortOrderToUse = customSortOrder !== undefined ? customSortOrder : sortOrder;
        
        console.log("🔄 [ListCustomer] Carregando página:", page, "Tamanho:", pageSize);
        console.log("🔍 [ListCustomer] customFilters recebido:", customFilters);
        console.log("🔍 [ListCustomer] filters do estado:", filters);
        console.log("🔍 [ListCustomer] Filtros que serão usados:", filtersToUse);
        console.log("📊 [ListCustomer] Ordenação:", sortByToUse, sortOrderToUse);
        
        setOpen(true);
        
        try {
            const item = await customerService.listCustomer(
                page, 
                pageSize, 
                filtersToUse,
                sortByToUse,
                sortOrderToUse
            );
            console.log("📡 [ListCustomer] Resposta da API:", item);
            
            if (item && item.success !== false) {
                if (item.data && Array.isArray(item.data) && item.pagination) {
                    console.log("✅ [ListCustomer] Dados recebidos:", {
                        dataLength: item.data.length,
                        pagination: item.pagination,
                        filters: filtersToUse
                    });
                    setListCustomer({
                        data: item.data,
                        pagination: item.pagination,
                    });
                }
            } else {
                console.error("❌ [ListCustomer] Erro na API:", item);
                setErrorMessage(item?.message || "Erro ao carregar dados");
            }
        } catch (error) {
            console.error("❌ [ListCustomer] Erro ao carregar dados:", error);
            setErrorMessage(error.message || "Erro ao carregar dados");
        } finally {
            setOpen(false);
        }
    };

    const handleFilterChange = (newFilters) => {
        console.log("🔍 [ListCustomer] Filtros alterados:", newFilters);
        console.log("🔍 [ListCustomer] Chamando API IMEDIATAMENTE com novos filtros");
        
        // Atualizar estado
        setFilters(newFilters);
        
        // Recarregar dados com novos filtros IMEDIATAMENTE (não espera setState)
        // Passa newFilters diretamente, não usa o estado
        loadPage(1, listCustomer.pagination.itemsPerPage || 10, newFilters);
    };

    const handleSortChange = (newSortBy, newSortOrder) => {
        console.log("📊 [ListCustomer] Ordenação alterada:", newSortBy, newSortOrder);
        
        // Atualizar estados
        setSortBy(newSortBy);
        setSortOrder(newSortOrder);
        
        // Recarregar dados com nova ordenação
        loadPage(
            listCustomer.pagination.currentPage || 1,
            listCustomer.pagination.itemsPerPage || 10,
            filters,
            newSortBy,
            newSortOrder
        );
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
            <>
                <Container maxWidth="lx" sx={{ bgcolor: '#EBEBEB', height: '100vh' }}>
                    
                    <DrawerPrincipal title={"Cliente"} divOpen={
                        <div>
                            <div>
                                <SimpleBackdrop
                                    open={open}
                                    handleClose={handleClose}
                                    title={"Carregando informações..."}
                                />
                                <div className="row mb-3">
                                    <CustomizedBreadcrumbs title1={"Home"} link1={"/"} title2={"Lista de Clientes"} link2={"#"}/>
                                </div>

                                <Paper sx={{width: '100%', margin: 'auto', overflow: 'hidden' }}>

                                    <AppBar
                                        position="static"
                                        color="default"
                                        elevation={0}
                                        sx={{ borderBottom: '1px solid rgba(0, 0, 0, 0.12)' }}
                                        >
                                        <Toolbar>
                                            <Grid container spacing={2} alignItems="center">
                                                <Grid item style={{width: 200}}>
                                                <h5>Lista de Clientes</h5>
                                                {/* <FormControl sx={{ m: 1, minWidth: 120 }}>
                                                    <Select
                                                    fullWidth
                                                    size="small"
                                                    value={search && search}
                                                    onChange={(e)=> {setSearch(e.target.value)}}
                                                    inputProps={{ 'aria-label': 'Without label' }}
                                                    >
                                                        <MenuItem value={"name"}>Nome</MenuItem>
                                                    </Select>
                                                </FormControl> */}
                                                </Grid>
                                                <Grid item xs>
                                                    {/* <TextField
                                                        fullWidth
                                                        placeholder="Pesquisar por nome"
                                                        onChange={(e)=> setInputSearch(e.target.value)}
                                                        InputProps={{
                                                        disableUnderline: true,
                                                        sx: { fontSize: '100' },
                                                        }}
                                                        variant="standard"
                                                    /> */}
                                                </Grid>
                                                <Grid item>
                                                    {/* <Button variant="outlined" onClick={(e) => {searchCustomer(inputSearch)}} startIcon={<SearchIcon />}>
                                                        Pesquisar
                                                    </Button> */}
                                                    {/* <SearchIcon color="inherit" sx={{ display: 'block' }} /> */}
                                                </Grid>
                                                <Grid item>
                                                        {
                                                            permission?.isinsert ? 
                                                            <Link to={"/customer"}>
                                                                <Button style={{background: 'black', color: '#FFF'}} sx={{ mr: 1 }}>
                                                                    <AddIcon /> Novo
                                                                </Button>
                                                            </Link>
                                                            : 
                                                            ""
                                                        }
                                                </Grid>
                                            </Grid>
                                        </Toolbar>
                                    </AppBar>

                                    <div style={{ width: '100%', padding: 10 }}>
                                        {errorMessage && (
                                            <div
                                                style={{
                                                    padding: "10px",
                                                    marginBottom: "10px",
                                                    backgroundColor: "#ffebee",
                                                    color: "#c62828",
                                                    border: "1px solid #ef5350",
                                                    borderRadius: "4px",
                                                }}
                                            >
                                                <strong>Erro:</strong> {errorMessage}
                                            </div>
                                        )}

                                        <TableCustomer 
                                            data={listCustomer} 
                                            onPageChange={loadPage}
                                            onFilterChange={handleFilterChange}
                                            onSortChange={handleSortChange}
                                        />
                                        {/* <TableCustomer key={listCustomer.length} list={listCustomer}/> */}
                                    </div>
                            </Paper>
                        </div>
                    </div>
                }/>
            </Container>
        </>
    );
}


export default ListCustomer;